import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Lock, Mail, GraduationCap } from "lucide-react";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("eq_admin_token", data.token);
      localStorage.setItem("eq_admin_email", data.email);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (e) {
      toast.error("Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center">
            <GraduationCap className="w-6 h-6 text-neutral-950" />
          </div>
          <div className="text-white">
            <div className="font-display font-black text-2xl">EQtech</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-neutral-400">Admin Portal</div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
          <h1 className="font-display font-bold text-2xl">Sign in</h1>
          <p className="text-sm text-neutral-500 mt-1">Access the EQtech Academy CMS</p>
          <div className="mt-6 space-y-3">
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400" />
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
                     className="w-full pl-11 pr-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:border-sky-500" data-testid="admin-login-email" />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400" />
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
                     className="w-full pl-11 pr-4 py-3 rounded-xl border border-neutral-200 focus:outline-none focus:border-sky-500" data-testid="admin-login-password" />
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary-eq w-full justify-center mt-6" data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
